import React from 'react';
import { FundoForm } from '../fundo_liquido/types';
import { FORMA_JURIDICA, MASTER_FIC, MOEDA, JUROS, CLASSE_ANGA_1, CLASSE_ANGA_2, anbimaN1Opts, anbimaN2Opts, anbimaN3Opts } from '../fundo_liquido/mock';
import { TextField, SelectField, CnpjField, CheckboxField, TextAreaField } from '../fundo_liquido/fields';

interface Props {
  form: FundoForm;
  onChange: (patch: Partial<FundoForm>) => void;
}

/** Campos 1:1 do fundo em modo edição (mesmo agrupamento por seção do resumo). */
const FundoEditDados: React.FC<Props> = ({ form, onChange }) => {
  const set = (patch: Partial<FundoForm>) => onChange(patch);

  return (
    <>
      <div className="fl-rev-section">
        <div className="fl-section-title">Identificação</div>
        <div className="fd-edit-grid">
          <CnpjField label="CNPJ" value={form.cnpj} onChange={v => set({ cnpj: v })} />
          <TextField label="Razão social" value={form.razao_social} onChange={v => set({ razao_social: v })} />
          <TextField label="Nome fantasia" value={form.nome_fantasia} onChange={v => set({ nome_fantasia: v })} />
        </div>
      </div>

      <div className="fl-rev-section">
        <div className="fl-section-title">Dados gerais</div>
        <div className="fd-edit-grid">
          <SelectField label="Moeda" value={form.moeda} options={MOEDA} onChange={v => set({ moeda: v })} />
          <SelectField label="Master / FIC" value={form.master_fic} options={MASTER_FIC} onChange={v => set({ master_fic: v })} />
          <TextField label="Código ANBIMA" value={form.codigo_anbima} onChange={v => set({ codigo_anbima: v })} />
          <TextField label="Constituição/início" value={form.data_lancamento} onChange={v => set({ data_lancamento: v })} />
          <TextField label="Encerramento" value={form.data_encerramento} onChange={v => set({ data_encerramento: v })} />
          <TextField label="Voice" value={form.voice} onChange={v => set({ voice: v })} />
          <SelectField label="Juros" value={form.juros} options={JUROS} onChange={v => set({ juros: v })} />
        </div>
        <div className="fd-edit-checks">
          <CheckboxField label="Ativo" checked={form.is_active} onChange={v => set({ is_active: v })} />
          <CheckboxField label="Conta no AUM" checked={form.count_on_aum} onChange={v => set({ count_on_aum: v })} />
          <CheckboxField label="Gera lâmina" checked={form.gera_lamina} onChange={v => set({ gera_lamina: v })} />
          <CheckboxField label="Paga gestão" checked={form.paga_gestao} onChange={v => set({ paga_gestao: v })} />
        </div>
        <TextAreaField label="Observação" full value={form.observacao} onChange={v => set({ observacao: v })} />
      </div>

      <div className="fl-rev-section">
        <div className="fl-section-title">Classificação</div>
        <div className="fd-edit-grid">
          <SelectField label="Classificação CVM" value={form.forma_juridica} options={FORMA_JURIDICA} onChange={v => set({ forma_juridica: v })} />
          <SelectField label="ANBIMA nível 1" value={form.classe_anbima_n1} options={anbimaN1Opts()}
            onChange={v => set({ classe_anbima_n1: v, classe_anbima_n2: '', classe_anbima_n3: '' })} />
          <SelectField label="ANBIMA nível 2" value={form.classe_anbima_n2} options={anbimaN2Opts(form.classe_anbima_n1)}
            onChange={v => set({ classe_anbima_n2: v, classe_anbima_n3: '' })} />
          <SelectField label="ANBIMA nível 3" value={form.classe_anbima_n3} options={anbimaN3Opts(form.classe_anbima_n1, form.classe_anbima_n2)}
            onChange={v => set({ classe_anbima_n3: v })} />
          <SelectField label="ANGA 1" value={form.classe_anga_1} options={CLASSE_ANGA_1} onChange={v => set({ classe_anga_1: v })} />
          <SelectField label="ANGA 2" value={form.classe_anga_2} options={CLASSE_ANGA_2} onChange={v => set({ classe_anga_2: v })} />
        </div>
      </div>
    </>
  );
};

export default FundoEditDados;
